import React, { useEffect, useMemo, useState } from 'react';
import { dayKey, fmtDay, fmtTime } from '../../lib/schedulingApi';

export default function SlotPicker({ slots, tz, value, onChange, showFree = false, emptyText = 'No open times in this window.' }) {
  const days = useMemo(() => {
    const m = new Map();
    (slots || []).forEach((s) => {
      const k = dayKey(s.start, tz);
      if (!m.has(k)) m.set(k, []);
      m.get(k).push(s);
    });
    return [...m.entries()];
  }, [slots, tz]);
  const [day, setDay] = useState(null);
  useEffect(() => {
    if (!days.length) return;
    if (!days.some(([k]) => k === day)) setDay(value ? dayKey(value, tz) : days[0][0]);
  }, [days]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!slots) return <p className="iv-small" data-testid="slot-picker-loading">Finding open times…</p>;
  if (!days.length) return <div className="iv-note is-warn" data-testid="slot-picker-empty">{emptyText}</div>;
  const current = days.find(([k]) => k === day) || days[0];
  return (
    <div data-testid="slot-picker">
      <div className="sc-days" role="tablist">
        {days.map(([k, list]) => {
          const [wd, ...rest] = fmtDay(list[0].start, tz).split(' ');
          return (
            <button type="button" key={k} className={`sc-day ${k === current[0] ? 'is-on' : ''}`} onClick={() => setDay(k)} data-testid={`slot-day-${k}`}>
              <span>{wd.replace(',', '')}</span><b>{rest.join(' ')}</b><small>{list.length} times</small>
            </button>
          );
        })}
      </div>
      <div className="sc-slots">
        {current[1].map((s) => (
          <button type="button" key={s.start} className={`sc-slot ${value === s.start ? 'is-on' : ''}`} onClick={() => onChange(s)} data-testid={`slot-${s.start}`}>
            {fmtTime(s.start, tz)}
            {showFree && s.free && <small>{s.free.length} free</small>}
          </button>
        ))}
      </div>
    </div>
  );
}
